<template>
  <div>
    <base-form :fields="fields" v-model="dataContainer" :warehouseId="warehouseId" ref="baseForm" @change="onChange"></base-form>
    <div class="btn-validation" v-if="dataContainer">
      <sc-button text="Validar" theme="primary" @click="onClickValidate()" :disabled="isValidated"/>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import {
  ScButton,
  ScToast,
} from '@intelipost-js/secure-components';
import BaseForm from '../base/BaseForm.vue';

const { mapMutations, mapActions } = createNamespacedHelpers(
  'integrations/integrationsAppSelfService',
);

export default {
  name: 'sc-credentials-form',
  components: {
    ScButton,
    ScToast,
    BaseForm,
  },
  props: {
    fields: {
      type: Array,
      required: true,
    },
    warehouseId: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      alreadyChecked: false,
      isValidated: false,
      dataContainer: {},
    };
  },
  methods: {
    ...mapMutations(['setLoading']),
    ...mapActions(['validateApp']),

    async onClickValidate() {
      const args = {
        app_id: this.$router.history.current.params.id,
        app_config: this.dataContainer,
      };

      this.setLoading(true);

      const response = await this.validateApp(args);

      this.setLoading(false);

      if (response.ok) {
        ScToast.open({
          message: 'Credenciais válidas',
          duration: 1000,
          type: 'is-success',
        });
        this.isValidated = true;
      } else {
        ScToast.open({
          message: response.message,
          duration: 20000,
          type: 'is-danger',
        });
        this.isValidated = false;
      }
    },
    validateConfig(config) {
      if (!this.$refs.baseForm.validateConfig(config)) {
        return false;
      }

      if (!this.isValidated) {
        ScToast.open({
          message: 'Valide as credenciais para prosseguir',
          type: 'is-danger',
        });
        return false;
      }

      return true;
    },
    onChange() {
      this.invalidate();
    },
    invalidate() {
      this.isValidated = false;
    },
  },
};
</script>
<style lang="scss" scoped>
 .btn-validation {
  margin-top: 10px;
 }
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/components/credentials/ScCredentialsForm.vue